var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52611",
    "data-name": "Group 52611",
    transform: "translate(-806 -4705.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    transform: "translate(806 4705.653)",
    fill: "#fff",
    stroke: "#93a750",
    strokeWidth: 1,
    strokeDasharray: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_91087",
    "data-name": "Path 91087",
    d: "M32.5,0A33.236,33.236,0,0,1,44.376,2.2,31.937,31.937,0,0,1,65,32c0,17.673-14.551,32-32.5,32S0,49.673,0,32,14.551,0,32.5,0Z",
    transform: "translate(811 4711.653)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Location",
    "data-name": "Iconly/Light/Location",
    transform: "translate(826.07 4725.724)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 34.859,
    height: 34.859,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Location",
    transform: "translate(7.212 4.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33958",
    d: "M0,11.1C.019,4.95,4.609-.021,10.252,0s10.2,5.026,10.183,11.179V11.3c-.069,4-2.118,7.7-4.629,10.586a27.506,27.506,0,0,1-4.779,4.29,1.162,1.162,0,0,1-1.62,0,27.456,27.456,0,0,1-6.723-6.864A15.08,15.08,0,0,1,0,11.141Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_740",
    cx: 3.275,
    cy: 3.571,
    rx: 3.275,
    ry: 3.571,
    transform: "translate(6.943 7.747)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.d6c4394ce89e1af74406aa38368e89f4.svg";
export { ForwardRef as ReactComponent };